import { Component, OnInit, Input, Inject, signal, OnChanges } from '@angular/core';
import { DateOptions, DATE_OPTIONS, LottosWalletItem, RewardsWalletQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-lottos-won-list-item',
  templateUrl: './lottos-won-list-item.component.html',
  styleUrls: ['./lottos-won-list-item.component.scss'],
})
export class LottosWonListItemComponent implements OnInit, OnChanges {
  @Input() lottoItem: LottosWalletItem;
  @Input() multi: boolean;
  @Input() showButton: boolean = true;
  @Input() orientation: 'landscape' | 'portrait' = 'portrait';
  @Input() redeemed: boolean = false;
  groupItem$: Observable<any>;
  screenType = ScreenType;
  expired = signal(false);

  constructor(
    @Inject(DATE_OPTIONS) public dateOption: DateOptions,
    private rewardsWalletQuery: RewardsWalletQuery
  ) {}

  ngOnInit() {
    this.groupItem$ = this.rewardsWalletQuery.selectItemsByGroupId(this.lottoItem.GroupId);
  }

  ngOnChanges(): void {
    const isExpired = DateTime.fromISO(this.lottoItem.ExpireDate as string, { zone: 'utc' }) < DateTime.utc();
    this.expired.set(isExpired);
  }
}
